import moment from "moment";
import React from "react";
import { FormDatePicker } from "components/DatePicker/SingleDatePicker";

interface DatePickerProps {
  validatorKey: string
  onDateChange: (newDate: moment.Moment) => void
  value: moment.Moment
}

const SingleShowDatePicker = (props: DatePickerProps) => {
  const onChange = (newDate: moment.Moment) => {
    props.onDateChange(newDate);
  };

  return <FormDatePicker
    dontUpdateOnInputChange
    validatorKey={props.validatorKey}
    minDate={moment(serverReference.constants.appointment.minDate)}
    maxDate={moment(serverReference.constants.appointment.maxDate)}
    value={props.value}
    onChange={onChange}
  />;
};

export default SingleShowDatePicker;
